{
  "pt": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "As reclamações de spam não podem ser reativadas aqui. Isto só pode ser feito manualmente através de {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Pesquisar",
      "selected": "Selecionado"
    }
  }
}
